import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import LinkWrapper from "@/components/linkWrapper";
import BackgroundImageWrapper from "@/components/backgroundImageWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment Page404WithBackgroundImageData on StrapiComponent404WithBackgroundImage {
    topic
    title
    description
    button {
      ...StrapiSharedLink
    }
    image {
      ...StrapiMediaSubquery
    }
  }
`;

function WithBackgroundImage({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <>
      {data.image && (
        <BackgroundImageWrapper
          image={data.image}
          className="min-h-screen bg-cover bg-top"
        >
          <div className="mx-auto max-w-7xl px-4 py-16 text-center sm:px-6 sm:py-24 lg:px-8 lg:py-48">
            {data.topic && (
              <MarkdownWrapper
                text={data.topic}
                markdownClassName="block text-base text-center text-opacity-50 text-text-black font-semibold tracking-wide uppercase"
              />
            )}
            {data.title && (
              <h1 className="mt-2 text-4xl font-extrabold tracking-tight text-text-white sm:text-5xl">
                <MarkdownWrapper text={data.title} />
              </h1>
            )}
            {data.description && (
              <MarkdownWrapper
                text={data.description}
                markdownClassName="mt-2 text-lg font-medium text-text-black text-opacity-50"
              />
            )}
            {(data.button?.overwriteTitle || data.button?.link?.title) && (
              <div className="mt-6">
                <LinkWrapper
                  to={data.button?.link?.url}
                  className="inline-flex items-center rounded-md border border-transparent bg-background-white bg-opacity-75 px-4 py-2 text-sm font-medium text-text-black text-opacity-75 sm:bg-opacity-25 sm:hover:bg-opacity-50"
                >
                  {data.button.overwriteTitle || data.button.link.title}
                </LinkWrapper>
              </div>
            )}
          </div>
        </BackgroundImageWrapper>
      )}
    </>
  );
}

WithBackgroundImage.propTypes = {
  data: PropTypes.object,
};

export default WithBackgroundImage;
